import { render, staticRenderFns } from "./employerHrConfig.vue?vue&type=template&id=5bb8a5c7"
import script from "./employerHrConfig.vue?vue&type=script&lang=js"
export * from "./employerHrConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports